let debounce = require('../../modules/debounce');
require('./filter.less');

let size = require('../../modules/size');
let functions = require('../../modules/functions');

jQuery(function() {
    var $filter = $('#js-filter');
    var $container = $filter.closest('.main-container');
    var $overlay = $('#overlay').addClass('overlay--filter');

    //при ресете формы вручную вызвать change у инпутов ценыт от/до,
    //чтобы заставить сработать смену визуальной части слайдера цен.
    $filter.find('form input[type=reset]').click(function() {
        var $form = $(this).closest('form');
        setTimeout(function() {
            $form.find('.priceslider__input').change();
        }, 100);
    });

    //развернуть скрытые варианты фильтра
    $(document).on('click', '.js-expand-filter-variants', function() {
        var $this = $(this);
        var $variantsBlock = $this.closest('.filter__variants');
        var $hiddenVarsBlock = $variantsBlock.find('.filter__hidden-variants');

        if ($variantsBlock.hasClass('filter__variants--full')) {
            $hiddenVarsBlock.css('max-height', 0);
            $variantsBlock.removeClass('filter__variants--full');
        } else {
            var trueHeight = functions.getTrueHeight($hiddenVarsBlock);

            $hiddenVarsBlock.css('max-height', trueHeight + 'px');
            $variantsBlock.addClass('filter__variants--full');
        }
    });

    //скрыть весь блок фильтра при клике по заголовку
    $(document).on('click', '.js-filter-title-expandable', function() {
        var $this = $(this);

        if ($this.hasClass('js-filter-title-inactive')) return;

        var $filterBlock = $this.closest('.filter__param');
        var $filterVariants = $filterBlock.find('.filter__variants');
        $filterVariants.css('max-height', $filterVariants.height() + 'px');
        var trueHeight = functions.getTrueHeight($filterVariants);

        if ($this.hasClass('filter__title--collapse')) {
            $filterVariants.css('max-height', trueHeight + 'px');
            $this.removeClass('filter__title--collapse');
            $filterBlock.removeClass('filter__param--collapsed');
            setTimeout(function() {
                $filterVariants.css('max-height', 'none');
            }, 500);
        } else {
            $filterVariants.css('max-height', trueHeight + 'px');
            setTimeout(function() {
                $filterVariants.css('max-height', 0);
                $this.addClass('filter__title--collapse');
                $filterBlock.addClass('filter__param--collapsed');
            }, 20);
        }
    });

    //кнопка, показывающая фильтр
    $(document).on('click', '#js-btn-filter', function() {
        showFilter($(this));
    });

    //кнопка, скрывающая фильтр
    $(document).on('click', '.js-hide-filter', function(e) {
        e.preventDefault();
        $('.js-filter-popup').remove();
        hideFilter();
    });

    //показать фильтр (мобильная и планшетная версии)
    function showFilter($btn) {

        if (window.innerWidth >= size.desktop) {
            //в десктопе такой кнопки нету
        } else if (window.innerWidth >= size.tablet) {

            $overlay.show(20, function() {
                $overlay.addClass('overlay--shown');
            });

            var pos = $btn.offset().top + $btn.innerHeight();
            $filter.css('top', pos + 'px');

            $filter.show(20, function() {
                $filter.addClass('filter--shown');
                $filter.find('.filter__common-title').width($btn.outerWidth() + 'px');
            });
        } else {
            $filter.addClass('filter--shown');
            $container.addClass('main-container--shifted-left');

            $filter.addClass('filter--autoheight');
            if ($filter.height() > $container.height()) $container.css('min-height', $filter.height() + 'px');
            $filter.removeClass('filter--autoheight');
        }
    }

    //скрытие фильтра
    function hideFilter() {
        if (window.innerWidth >= size.tablet) {
            $overlay.removeClass('overlay--shown');
            setTimeout(function() {
                $overlay.hide();
            }, 350);
            $filter.removeClass('filter--shown');
        } else {
            $container.removeClass('main-container--shifted-left');
            $container.css('min-height', '0');

            $filter.removeClass('filter--shown');
        }
    }

    //настройка фильтра при смене разрешения,
    //очищение от стилей и классов, нужных только для других  разрешениях
    function setUpFilter() {
        var $desktopHolder = $('#js-filter-desktop-holder');

        if (window.innerWidth >= size.tablet) {
            if ($filter.hasClass('filter--mobile')) {
                $filter.removeClass('filter--mobile filter--shown');
                $container.removeClass('main-container--shifted-left');
            }

            $filter.find('.js-filter-title-expandable').addClass('js-filter-title-inactive');
            $filter.find('.filter__title--collapse').removeClass('filter__title--collapse');
            $filter.find('.filter__param--collapsed').removeClass('filter__param--collapsed');
            $filter.find('.filter__variants--visible').css('max-height', 'none');
        } else {
            $filter.find('.js-filter-title-expandable').removeClass('js-filter-title-inactive');
        }

        if (window.innerWidth >= size.desktop) {
            $filter.removeClass('filter--tablet filter--mobile filter--shown').show();
            $overlay.removeClass('overlay--shown');
            setTimeout(function() {
                $overlay.hide();
            }, 350);

            $desktopHolder.append($filter);
        } else if (window.innerWidth >= size.tablet) {
            var $btn = $('#js-btn-filter');
            $filter.find('.filter__common-title').width($btn.outerWidth() + 'px');
            $filter.removeClass('filter--mobile');
            $filter.addClass('filter--tablet');
            $container.append($filter);
        } else {
            if ($filter.hasClass('filter--tablet'))
                $filter
                    .removeClass('filter--tablet filter--shown')
                    .css('top', 0)
                    .show();

            $overlay.removeClass('overlay--shown');
            setTimeout(function() {
                $overlay.hide();
            }, 350);

            $filter.addClass('filter--mobile');
            $container.append($filter);
        }
    }

    debounce.setResizeDebounce(setUpFilter);
    setUpFilter();

    //скрыть фильтр если кликнули по контенту (мобильная версия)
    $(document).on('click', '.main-container--shifted-left .container', function(e) {
        e.stopPropagation();
        e.preventDefault();

        $container.removeClass('main-container--shifted-left');
        $container.css('min-height', '0');

        $filter.removeClass('filter--shown');
    });

    //скрыть фильтр при клике по оверлею (планшетная версия)
    $overlay.click(function() {
        $overlay.removeClass('overlay--shown');
        setTimeout(function() {
            $overlay.hide();
        }, 350);

        if (window.innerWidth <= size.desktop) {
            $filter.removeClass('filter--shown');
            setTimeout(function() {
                $filter.hide();
            }, 350);
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/filter/filter.js